import {ChangeDetectorRef, Component, ViewChild,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {CustomerAccountService} from "../../../services/customer/account/customer-account.service";
import {TranslateService} from '@ngx-translate/core';
import {AccountDefinition} from "../../../model/customer/account-definition";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {ExchangeDetail} from "../../../model/exchange/exchange-detail";
import {AccountType} from "../../../model/exchange/account-type";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {CCRoles} from "../../../model/security/cc-roles-type";
import {AppConfigService} from "../../../services/app-config.service";
import {
  CustomerAccountDataLoadingService
} from "../../../services/customer/account/customer-account-data-loading.service";
import {
  CustomerAccountTableConfigService
} from "../../../services/customer/account/customer-account-table-config.service";
import {
  CustomerAccountFormConfigService
} from "../../../services/customer/account/customer-account-form-config.service";
import {CrudTableComponent} from "../../../crystal-elements/crud/crud-table.component";
import {FieldsService} from "../../../services/common/fields-service";
import {WebUserSettings} from "../../../model/security/user-settings";

@Component({
  selector: 'app-acct',
  templateUrl: './account.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class AccountComponent extends CrudBaseComponent<AccountDefinition> {

  batchUpdateDialogVisible: boolean = false;
  batchAction: "update" | "clone" = "update";

  @ViewChild('crudTable')
  public crudTable: CrudTableComponent;

  constructor(cdref: ChangeDetectorRef,
              commonFieldService: CommonFieldService,
              customerAccountService: CustomerAccountService,
              readonly appConfigService: AppConfigService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              private readonly tableConfigService: CustomerAccountTableConfigService,
              private readonly formConfigService: CustomerAccountFormConfigService,
              protected dataLoadingService: CustomerAccountDataLoadingService,
              private readonly fieldsService: FieldsService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = customerAccountService;
    this.newRecord = new AccountDefinition();
    this.newRecord.enabled = true;
    this.newRecord.exchangeCode = ExchangeDetail.ALL;
    this.newRecord.accountTypeCode = AccountType.GIVE_UP_CODE;
    this.writeRoles = CCRoles.ROLES_CUSTOMER_WRITE;
    this.transPartKey = 'account';
    this.fieldId = 'id';
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = this.tableConfigService.loadConfig(this);
    this.formConfig = this.formConfigService.loadConfig(this)
    this.initButtons();
  }

  protected initButtons() {
    this.headerButtonConfig.splice(3, 0,
      {
        'tooltip': this.translateService.instant('page.' + this.transPartKey + '.table.batch_update_button'),
        'icon': 'fas fa-pen-to-square',
        class: ' p-button-help',
        command: records => this.batchUpdate(),
        enabled: () => !this.hasOneSelection() && this.hasMultipleSelection()
      },
      {
        'tooltip': this.translateService.instant('page.' + this.transPartKey + '.table.batch_clone_button'),
        'icon': 'fa-regular fa-clone cc-ico-clone-edit',
        class: ' p-button-help',
        command: records => this.batchClone(),
        enabled: () => !this.hasOneSelection() && this.hasMultipleSelection()
      },
    );
    this.headerButtonConfig = [...this.headerButtonConfig];

    this.contextMenuConfig.splice(2, 0,
      {
        id: 'batch-update',
        label: this.translateService.instant('page.' + this.transPartKey + '.table.batch_update_button'),
        icon: 'fas fa-pen-to-square',
        command: () => {
          this.batchUpdate();
        }
      },
      {
        id: 'batch-clone',
        label: this.translateService.instant('page.' + this.transPartKey + '.table.batch_clone_button'),
        icon: 'fa-regular fa-clone cc-ico-clone-edit',
        command: () => {
          this.batchClone();
        }
      }
    );
    this.contextMenuConfig = [...this.contextMenuConfig];
  }

  onFormShow() {
    this.dataLoadingService.filterCustomers(this.formRecord);
    this.dataLoadingService.filterExchanges(this.formRecord);
    this.dataLoadingService.filterAccountType(this.formRecord);
    this.dataLoadingService.refreshBrokerageTables(this.formRecord);
    this.dataLoadingService.refreshMoneyOwners(this.formRecord);
  }

  protected initData(): void {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;

    this.tracker = this.fieldsService.createTracker();

    this.tracker.progress.subscribe(value => {
      this.settingsFormLoadingProgressValue = value;
    });

    this.dataLoadingService.loadData(this);
  }


  private batchUpdate() {
    this.doBatchAction("update");
  }

  private batchClone() {
    this.doBatchAction("clone");
  }

  private doBatchAction(action: "update" | "clone") {
    if (this.selectedRecords && this.selectedRecords.length > 0) {
      this.formRecord = {...this.selectedRecords[0]};
    }
    this.onFormShow();

    this.batchUpdateDialogVisible = true;
    this.batchAction = action;
  }

  refreshContextMenu() {
    this.contextMenuConfig.forEach(menu => {
      if (menu.id === 'batch-update' || menu.id === 'batch-clone') {
        menu.disabled = this.hasOneSelection() || !this.hasMultipleSelection()
      }
    });
    this.contextMenuConfig = [...this.contextMenuConfig];
  }

  public onSaved() {
    this.loadRecords();
  }
}

